/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Fw_Tpl_FeaturesInputs */

const en_fw_tpl_features = /** @type {(inputs: Fw_Tpl_FeaturesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} features`)
};

const id_fw_tpl_features = /** @type {(inputs: Fw_Tpl_FeaturesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} fitur`)
};

/**
* | output |
* | --- |
* | "{n} features" |
*
* @param {Fw_Tpl_FeaturesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_features = /** @type {((inputs: Fw_Tpl_FeaturesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_FeaturesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_features(inputs)
	return en_fw_tpl_features(inputs)
});